import { parseBoolean } from '@/utils/parseBoolean';

export function resolveProductOpenInNewTab(
  productId: string,
  apiValue?: boolean,
): boolean {
  const runtimeOverride =
    window.environment?.products?.[productId]?.openInNewTab;

  if (runtimeOverride !== undefined) {
    return parseBoolean(runtimeOverride);
  }

  return apiValue ?? false;
}
